@if (translatedContent) {
  <div class="content"
    attr.id="wrapper-{{id}}">
    <div class="sr-only" [innerHTML]="translatedContent"></div>
    @if (active) {
      <div
        class="content__background"
        aria-hidden="true">
      </div>
    }
    <div class="content__inner"
      aria-hidden="true"
      [class.show]="show"
      #moreContent
      innerHTML="{{ translatedContent }}">
    </div>
  </div>
}
@if (active) {
  <p class="more" aria-hidden="true">
    <button theme="plain" htm-button (click)="changeState()" [attr.data-test-id]="'more-block-toggle-button-' + this.content">
      @if (!show) {
        {{ 'button.show_more' | translate }}
      }
      @if (show) {
        {{ 'button.show_less' | translate }}
      }
    </button>
  </p>
}
